

















































import {Component, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import Error from './error.class';

@Component
export default class ErrorAggregator extends Vue {
  @Prop({
    default: null
  })
  value!: string | string[] | Error[];

  @Emit('input')
  onInput() {}

  @Prop({
    default: false
  })
  active!: boolean;

  @Prop({
    default: true
  })
  fixErrorCount!: boolean;

  @Emit('update:active')
  onUpdateActive(value: boolean) {
    this.pActive = value;
  }

  @Watch('active')
  onActiveChanged(value: boolean, oldValue: boolean) {
    this.pActive = value;
  }

  pActive: boolean = false;

  get errorList() : Error[] {
    return !this.value
      ? []
      : typeof(this.value) === 'string'
        ?  [ this.stringToError(this.value) ]
        : Array.isArray(this.value)
          ? (this.value as any[])
            .map((error) => typeof error === 'string'
              ? this.stringToError(error)
              : error
            )
          : [];
  }

  get errorCount() {
    return this.fixErrorCount && this.errorList.length > 1
      ? this.errorList.length - 1
      : this.errorList.length;
  }

  get isNoErrors() {
    return this.errorList.length === 0;
  }

  data () {
    this.pActive = this.active;
    return {
      pActive: this.pActive
    };
  }

  handleCounterClick() {
    if(!this.isNoErrors) {
      this.onUpdateActive(!this.pActive);
    }
  }

  handleListClose() {
    this.onUpdateActive(false);
  }

  stringToError(message: string) {
    return { message };
  }
}
